import { render, staticRenderFns } from "./CreateNewsComment.vue?vue&type=template&id=014b3016&scoped=true&"
import script from "./CreateNewsComment.vue?vue&type=script&lang=js&"
export * from "./CreateNewsComment.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewsComment.vue?vue&type=style&index=0&id=014b3016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014b3016",
  null
  
)

export default component.exports